module.exports = __webpack_public_path__ + "static/img/before_sixteen.9f054b79.png";